import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import { Carousel, Slide } from 'vue-carousel';
Vue.component('mdmCarousel', Carousel);
Vue.component('mdmSlide', Slide);